import { Fetch } from "./misc";
import AuthService from "./accountAuth";
import { store } from "../store";
import { clearProfile } from "../state_management/actions/account";

/**
 * Fetch wrapper for endpoints behind the `auth:customer` guard.
 * Attaches the bearer token and, on 401 (token invalid/revoked),
 * clears the local token and profile before rethrowing.
 */
export const customerFetch = async (url: string, options?: RequestInit) => {
  return await Fetch(url, {
    ...options,
    headers: {
      ...AuthService.getAuthHeader(),
      ...options?.headers
    }
  }).catch((error: { status?: number }) => {
    if (error?.status === 401) {
      AuthService.clearAuthToken();
      store.dispatch(clearProfile());
    }
    throw error;
  });
};
